import React from 'react';

const Title = ({
	as,
	size,
	className,
	children
}) => {
	const Tag = as ? as : 'h2';

	return (
		<Tag
			className={`
				font-serif text-indigo-950 font-bold mb-4
				${size ? size : 'text-3xl'}
				${className ?? ''}
			`}
		>
			{children}
		</Tag>
	);
};

export default Title;
